import { useLazyQuery, useMutation } from "@apollo/client";
import { Col, Form as AntForm, Row } from "antd";
import { motion } from "framer-motion";
import { debounce } from "lodash";
import React, { useState } from "react";
import countryList from "react-select-country-list";
import { onBoardTransition } from "../../animation/index";
import { ADD_EDUCATION, SCHOOL_SEARCH } from "../../app/apollo/index";
import { StepProp } from "../../constants/interfaces";
import { DropDown } from "../../globalComponents/DropDown";
import { Label } from "../../globalComponents/globalStyle";
import { LoggerButton, TextInput } from "../../globalComponents/Index";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { InputDiv, StyledAutoComplete, StyledDataPicker } from "./Style";

interface Logintype {
  email: string;
  password: string;
}

export const Step1: React.FC<StepProp> = ({ back, next }) => {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = React.useState<any>({});

  const [schoolSearch, searchSchoolData] = useLazyQuery(SCHOOL_SEARCH);
  const [addEducationDetails] = useMutation(ADD_EDUCATION);
  const options = React.useMemo(() => countryList().getData(), []);
  //   const changeHandler = async (value: any) => {
  //     // setValue(value);

  //   };

  const onChange = async (value: string) => {
    console.log("the value is ", value);
    try {
      schoolSearch({
        variables: {
          byName: value,
        },
      });
    } catch (e: any) {
      console.log("error", e);
    }
  };
  console.log("the response of query is", searchSchoolData?.data?.schoolSearch);

  const onFinisher = (value: any, options: any) => {
    setValue(options);
  };
  const debounceOnChange = React.useCallback(debounce(onChange, 500), []);
  const onFinish = async (values: any) => {
    setLoading(true);
    console.log(value);
    console.log(values);
    const { year } = values;
    console.log("the year is", year.format("YYYY-MM-DD"));
    try {
      const response = await addEducationDetails({
        variables: {
          school_id: value?.key,
          schoolName: value?.value,
          endYear: year.format("YYYY-MM-DD"),
          course: values?.course,
        },
      });
      if (response) {
        setLoading(false);
        if (response.data?.addEducationDetails?.success) {
          NotificationAlert(
            "success",
            "Successful",
            response?.data?.addEducationDetails?.msg
          );
          next();
        } else {
          NotificationAlert(
            "error",
            "Error",
            response?.data?.addEducationDetails?.msg
          );
        }
      }
      //   console.log("update education response is ", response);
    } catch (e) {
      setLoading(false);
      NotificationAlert("error", "Error", "Unable to Add  Education Detail");
      console.log(e);
    }
    // next();
  };
  const dateFormat = "YYYY/MM/DD";

  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  return (
    <motion.div
      variants={onBoardTransition}
      exit="out"
      animate="in"
      initial="initial"
    >
      <AntForm
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <AntForm.Item
          name="country"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Select Country</h3>
            </Label>
          }
        >
          <div>
            <DropDown
              required={true}
              placeholder="Select a Country"
              values={options}
              //   onChange={changeHandler}
            />
          </div>
        </AntForm.Item>
        <AntForm.Item
          name="schoolName"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Name of School</h3>
            </Label>
          }
        >
          <InputDiv>
            <StyledAutoComplete
              onChange={debounceOnChange}
              onSelect={onFinisher}
              placeholder="Enter school name"
            >
              {searchSchoolData?.loading ? (
                <StyledAutoComplete.Option value={""}>
                  Loading...
                </StyledAutoComplete.Option>
              ) : (
                searchSchoolData?.data?.schoolSearch.map((val: any) => (
                  <StyledAutoComplete.Option key={val?.id} value={val?.name}>
                    {val?.name}
                  </StyledAutoComplete.Option>
                ))
              )}
            </StyledAutoComplete>
          </InputDiv>
        </AntForm.Item>
        <AntForm.Item
          name="course"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Course of Study</h3>
            </Label>
          }
        >
          <div>
            <TextInput
              required={true}
              type="text"
              placeholder="Enter course of study"
              name="course"
            />
          </div>
        </AntForm.Item>
        <AntForm.Item
          name="year"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Year of Graduation</h3>
            </Label>
          }
        >
          {/* <div> */}
          <StyledDataPicker
            // defaultValue={moment("2015/01/01", dateFormat)}
            format={dateFormat}
          />
          {/* </div> */}
        </AntForm.Item>
        <br />
        <Row justify="space-between">
          <Col xs={{ span: 9 }} md={{ span: 9 }}>
            {" "}
            <LoggerButton
              onClick={() => back()}
              colorProp={true}
              width="100%"
              text="Back"
            />
          </Col>
          <Col xs={{ span: 9 }}>
            {" "}
            <LoggerButton
              loading={loading}
              htmlType="submit"
              width="100%"
              text="Next"
            />
          </Col>
        </Row>
      </AntForm>
    </motion.div>
  );
};
